import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { AuthenticationService } from '../../@core/services/authentication.service';

@Component({
  selector: 'index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  constructor(
    private titleService: Title, 
    public authenticationService: AuthenticationService,  
    private metaService: Meta,) { }

  ngOnInit() {    
    this.titleService.setTitle("Livraison de colis | Nationex");
  }

}
